
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5563d8ff&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./GoodZoom.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./GoodZoom.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5563d8ff!../../node_modules/vue-loader/lib/selector?type=template&index=0!./GoodZoom.vue"),
  /* scopeId */
  "data-v-5563d8ff",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/GoodZoom.vue
// module id = 86
// module chunks = 1